import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import i18n from "i18next";

import { DefaultRowCell } from "../../../../Layout/SortedList";
import ContactRowCell from "./ContactRowCell";

export default class ListRow extends PureComponent {
  static propTypes = {
    item: PropTypes.object.isRequired,
    isMobile: PropTypes.bool
  };

  static defaultProps = {
    isMobile: false
  };

  render() {
    const { isMobile } = this.props;
    const { reps = [] } = this.props.item;
    const [firstGroupedRep = {}] = reps;

    return (
      <div role="row" tabIndex="0" className="sorted-list__row --grouping">
        <DefaultRowCell className="--x4" value={firstGroupedRep.productFamily} header={isMobile ? i18n.t("representative.productFamily") : ""} />
        <DefaultRowCell
          className="--no-padding --x4"
          value={firstGroupedRep.representativeType}
          header={isMobile ? i18n.t("representative.type") : ""}
        />
        <DefaultRowCell
          className="--no-padding --x4"
          value={firstGroupedRep.representativeName}
          header={isMobile ? i18n.t("representative.name") : ""}
        />
        <ContactRowCell className="--no-padding --x8" reps={reps} header={isMobile ? i18n.t("representative.contactDetails") : ""} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PurchaseOrder/OrderPage/Representative/List/ListRow.js